import { useEffect, useState } from "react";
import { pub } from "@/lib/api";
import { Shell } from "./Shell";

export default function LegalPage({ doc }) {
  const [text, setText] = useState("");
  useEffect(() => { pub.get(`/legal/${doc}`).then((r) => setText(r.data.text)).catch(() => {}); }, [doc]);
  return (
    <Shell testid={`legal-${doc}-page`}>
      <article className="px-5 sm:px-12 pt-10 max-w-2xl">
        <h1 className="w1-display text-2xl sm:text-3xl text-[color:var(--w1-blue)] mb-8">{doc === "privacy" ? "PRIVACY POLICY" : "TERMS"}</h1>
        <div data-testid={`legal-${doc}-text`} className="whitespace-pre-wrap text-sm leading-7 text-[color:var(--w1-text)] opacity-90">{text}</div>
        <p className="mt-8 text-xs text-[color:var(--w1-muted)]">333SOS is operated by JunoVesta, LLC.</p>
      </article>
    </Shell>
  );
}
